// extracted by mini-css-extract-plugin
module.exports = {"block":"offer_block__yd0pE","text":"offer_text__3onPA","link":"offer_link__1icF0"};